import { render, staticRenderFns } from "./ObservatoryControlLayer.vue?vue&type=template&id=4812cba8&scoped=true&"
import script from "./ObservatoryControlLayer.vue?vue&type=script&lang=js&"
export * from "./ObservatoryControlLayer.vue?vue&type=script&lang=js&"
import style0 from "./ObservatoryControlLayer.vue?vue&type=style&index=0&id=4812cba8&prod&lang=scss&"
import style1 from "./ObservatoryControlLayer.vue?vue&type=style&index=1&id=4812cba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812cba8",
  null
  
)

export default component.exports